<template>
  <InertiaLink
    :href="element.videoPageUrl"
    class="tw-block hover:tw-text-current"
  >
    <div
      class="pentagon-background pentagon-position tw-rounded-md tw-border tw-border-neutral-200 tw-p-5 tw-transition-shadow hover:tw-shadow-md"
    >
      <PlayIcon class="tw-h-6 tw-w-6 tw-text-primary-500" />
      <div class="tw-mt-1 tw-font-semibold">
        {{ element.title }}
      </div>
      <time class="tw-text-xs tw-text-neutral-500">
        {{ formatDate(element.createdAt, 'dd MMMM yyyy') }}
      </time>
      <div
        class="tw-mt-4 tw-flex tw-items-center tw-justify-between tw-space-x-4"
      >
        <div class="tw-flex tw-items-center tw-space-x-2">
          <Avatar
            :src="$page.props.mentor.avatarUrl"
            :alt="`${$page.props.mentor.name}'s avatar`"
            size="sm"
            class="tw-shrink-0"
          />
          <div class="tw-text-xs">
            <div class="tw-font-semibold">{{ $page.props.mentor.name }}</div>
            <div class="tw-font-medium tw-text-neutral-400">
              {{ $page.props.mentor.professionTitle }}
            </div>
          </div>
        </div>
        <div class="tw-text-xs tw-font-medium tw-text-neutral-400">
          {{ duration }}
        </div>
      </div>
    </div>
  </InertiaLink>
</template>

<script setup>
import PlayIcon from '@/assets/images/icons/play.svg'
import Avatar from '@/shared/components/avatar/Avatar.vue'
import { formatDuration } from '@/shared/utils/videoDuration.js'
import { computed } from 'vue'
import { useDateManager } from '@/shared/composables/useDateManager.js'

const props = defineProps({
  element: {
    type: Object,
    required: true,
  },
})

const { formatDate } = useDateManager()

const duration = computed(() => {
  return formatDuration(props.element.duration)
})
</script>

<style scoped>
.pentagon-position {
  background-position: -200px 0;
}
</style>
